export default __webpack_public_path__ + "static/media/icon-cicle-success-white.0eaac42b.svg";